import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#399342',
        secondary: '#6b7480',
        accent: '#2196f3',
        error: '#ff5722',
        warning: '#f44336',
        info: '#3f51b5',
        success: '#4caf50'
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
